export default __webpack_public_path__ + "static/media/petgramImg_2.b1239978.webp";